import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useEditCartItem = (): ((id: string) => void) => {
	const navigate = useNavigate();

	return useCallback(id => navigate(`/product/edit/${id}`), [navigate]);
};
